import React from 'react'
import { browserHistory, Router } from 'react-router'
import { Provider } from 'react-redux'
import PropTypes from 'prop-types'
import CssBaseline from '@material-ui/core/CssBaseline'

class App extends React.Component {
	static propTypes = {
		store: PropTypes.object.isRequired,
		routes: PropTypes.object.isRequired,
	}
	render () {
		return (
			<React.Fragment>
				<CssBaseline/>	
				<Provider store={this.props.store}>
					<div style={{ height: '100vh' }}>
						<Router history={browserHistory} children={this.props.routes} />
					</div>
				</Provider>
			</React.Fragment>
		)
	}
}

export default App  


// WEBPACK FOOTER //
// ./src/components/App.js